/**
 * useDebugCapability — zentrale Sichtbarkeits-Prüfung für den Debug-Layer.
 *
 * Wiederverwendung des bestehenden RBAC-Modells über `useUserRoles`. Keine
 * parallele Rollenlogik. `spot_admin` ist im aktuellen Modell bereits in
 * `isAdmin` enthalten (siehe `useUserRoles`), Admins/Super-Admins ebenso.
 */
import { useUserRoles } from '@/hooks/useUserRoles';

export interface DebugCapability {
  /** Darf den Floating-Button + das Panel überhaupt sehen. */
  canUseDebugLayer: boolean;
  /** Darf `payloadVisibility='admin_safe'` Inhalte gerendert sehen. */
  canSeeAdminPayload: boolean;
  loading: boolean;
}

export function useDebugCapability(): DebugCapability {
  const { isAdmin, isSuperAdmin, loading } = useUserRoles();
  const canUseDebugLayer = isAdmin || isSuperAdmin;
  return {
    canUseDebugLayer,
    canSeeAdminPayload: canUseDebugLayer,
    loading,
  };
}
